import { SET_STORY } from 'client/constants/actions';
import { StoryModel } from 'types/story';

/**
 * @param payload {Object} Story object
 * @return {{type: *, payload: *}}
 */
export function setStory(payload: StoryModel) {
	return {
		type: SET_STORY,
		payload,
	};
}
